import { render, staticRenderFns } from "./attraction.vue?vue&type=template&id=1c268765&scoped=true&"
import script from "./attraction.vue?vue&type=script&lang=js&"
export * from "./attraction.vue?vue&type=script&lang=js&"
import style0 from "./attraction.vue?vue&type=style&index=0&id=1c268765&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c268765",
  null
  
)

export default component.exports